<template>
    <uiModal :title="title" icon="fal fa-user-lock" :name="name" size="nn">
        <div v-if="isSaving" class="loading-modal">
            <ui-load-indicator :h="50" :stroke="8" bg-color="#DFE5EC" color="#69D296" />
        </div>
        <template v-else>
            <div class="header-content">
                Selecione o grupo de usuários que poderão visualizar a tabela de vendas
            </div>

            <transfer-list :originMessage="'Quem não pode visualizar?'" :targetMessage="'Quem pode visualizar?'"
                :searchMessage="'Buscar grupos'" :search-origin.sync="searchOrigin" :search-target.sync="searchTarget"
                :actionsDisable="isSaving" 
                :to-right-action="addGroupPermission"
                :to-left-action="removeGroupsPermission" 
                :active-right-action="hasActiveNotAllowedGroups"
                :active-left-action="hasActiveAllowedGroups" 
                padding-container="0px 30px 45px 30px"
                titlePadding="13.5px 12px 12px 15px" 
                titleFontSize="13px"
                 containerHeight="370px"
                >

                <template #sourceList>
                    <div v-if="loading" class="loading">
                        <ui-load-indicator :h="50" :stroke="8" bg-color="#DFE5EC" color="#69D296" />
                    </div>
                    <div class="list" v-else>
                        <div class="list-item-empty" v-if="filteredNotAllowedGroups.length == 0">
                            <span>Nenhum grupo de usuário encontrado</span>
                        </div>
                        <span class="list-item" v-for="group in filteredNotAllowedGroups" :key="group.id"
                            @click="toggleGroupActive(group.id, false)" :class="{ active: group.active }">
                            {{ group.nameTrans }}
                        </span>
                    </div>
                </template>
                <template #targetList>
                    <div v-if="loading" class="loading">
                        <ui-load-indicator :h="50" :stroke="8" bg-color="#DFE5EC" color="#69D296" />
                    </div>
                    <div class="list" v-else>
                        <div class="list-item-empty" v-if="filteredAllowedGroups.length == 0">
                            <span>Nenhum grupo de usuário encontrado</span>
                        </div>
                        <span class="list-item" v-for="group in filteredAllowedGroups" :key="group.id"
                            @click="toggleGroupActive(group.id, true)" :class="{ active: group.active }">
                            {{ group.nameTrans }}
                        </span>
                    </div>
                </template>
            </transfer-list>
        </template>

        <template #footer>
            <div class="footer-content">
                <span>
                    <b :style="{ color: selectedGroups.length == 0 ? '' : '#0091FF' }">
                        {{ selectionMessage }}
                    </b>
                    <template v-if="selectedGroups.length > 0">
                        selecionado{{ selectedGroups.length == 1 ? '' : 's' }}.
                    </template>
                </span>
                <div class="actions">
                    <ui-button design="md success" @click="submitGroups" :disabled="!canSubmit || isSaving"> 
                            <ui-load-indicator v-if="isSaving" :h="20" :stroke="4" bg-color="#DFE5EC" color="#69D296" />
                            {{ isSaving  ? 'Salvando' : 'Salvar' }}
                    </ui-button>
                </div>
            </div>
        </template>
    </uiModal>
</template>
<script>
import TransferList from '@/components/ui/transfer-list'
import { groups, salesTable } from '@/services/axios'
import { uiModal } from '@/components/ui/modal'
import { uiLoadIndicator } from '@/components/ui'
import { uiButton } from '@/components/ui/buttons'
import { orderUserGroups } from '@/assets/js/data'
import { mapGetters } from 'vuex'

export default {
    name: 'ui-modal-permissions-sales-table',
    components: {
        TransferList,
        uiModal,
        uiLoadIndicator,
        uiButton
    },
    data() {
        return {
            title: 'Permissões - Tabela de Vendas',
            name: 'permissions',
            groups: [],
            allowedGroups: [],
            notAllowedGroups: [],
            searchOrigin: '',
            searchTarget: '',
            loading: false,
            isSaving: false,
            isAllowedGroupsEmpty: true,
            isNotAllowedGroupsEmpty: true,
            form: {
                salesTableVisibility: {
                    groups: []
                }
            },
            oldForm: {},
        };
    },

    computed: {
        ...mapGetters('salesTable', {
            salesTable: 'getSalesTable'
        }),
        selectionMessage() {
            if (this.selectedGroups.length == 0) return 'Nenhum grupo de usuário selecionado.';
            return `${this.selectedGroups.length} grupo${this.selectedGroups.length == 1 ? '' : 's'} de usuário${this.selectedGroups.length == 1 ? '' : 's'} `;
        },
        selectedGroups() {
            return this.groups.filter(group => group.active);
        },
        filteredNotAllowedGroups() {
            return this.notAllowedGroups.filter(group =>
                group.nameTrans.toLowerCase().includes(this.searchOrigin.toLowerCase())
            );
        },
        filteredAllowedGroups() {
            return this.allowedGroups.filter(group =>
                group.nameTrans.toLowerCase().includes(this.searchTarget.toLowerCase())
            );
        },
        hasActiveAllowedGroups() {
            return this.allowedGroups.length > 0 && this.allowedGroups.some(group => group.active);
        },
        hasActiveNotAllowedGroups() {
            return this.notAllowedGroups.length > 0 && this.notAllowedGroups.some(group => group.active);
        },
        canSubmit() {
            return JSON.stringify(this.form) != JSON.stringify(this.oldForm)
        },
    },
    mounted() {
        this.$root.$on('modal-open-permissions', () => {
            this.resetState();
            this.loadGroups();
        });
        this.copyForm()
    },
    beforeDestroy() {
        this.$root.$off('modal-open-permissions');
    },
    watch: {
        allowedGroups: {
            handler(newVal) {
                this.isAllowedGroupsEmpty = newVal.length === 0;
            },
            deep: true
        },
        notAllowedGroups: {
            handler(newVal) {
                this.isNotAllowedGroupsEmpty = newVal.length === 0;
            },
            deep: true
        },
    },
    methods: {
        resetState() {
            this.form = {
                salesTableVisibility: {
                    groups: []
                }
            };
            this.groups = [];
            this.allowedGroups = [];
            this.notAllowedGroups = [];
            this.searchOrigin = '';
            this.searchTarget = '';
            this.loading = false;
            this.isSaving = false;
            this.isAllowedGroupsEmpty = true;
            this.isNotAllowedGroupsEmpty = true;
        },
        loadGroups() {
            this.isAllowedGroupsEmpty = this.isNotAllowedGroupsEmpty = this.loading = true
            if (this.salesTable?.permissions) {
                this.form = {
                    salesTableVisibility: {
                        groups: JSON.parse(this.salesTable?.permissions)?.salesTableVisibility?.groups
                    }
                };
                this.copyForm()
            }
            groups.getGroups('groups', {})
                .then(response => {
                    this.groups = [];
                    this.allowedGroups = [];
                    this.notAllowedGroups = [];
                    this.groups = orderUserGroups(response.data.map(group => ({
                        id: group.id,
                        name: group.name,
                        nameTrans: group.nameTrans,
                        active: false,
                    })))
                    if (!this.salesTable.permissions) {
                        this.allowedGroups = this.groups
                        this.form.salesTableVisibility.groups = this.groups.map(group => group.id)
                        this.copyForm()
                        return
                    }
                    this.allowedGroups = this.groups.filter(group =>
                        this.form.salesTableVisibility.groups.includes(group.id)
                    );
                    this.notAllowedGroups = this.groups.filter(group =>
                        !this.form.salesTableVisibility.groups.includes(group.id)
                    );
                })
                .catch(error => {
                    this.$toastr.e(error.data?.msg || 'Erro ao carregar grupos de usuário.');
                })
                .finally(() => {
                    this.isAllowedGroupsEmpty = this.isNotAllowedGroupsEmpty = this.loading = false
                });
        },
        toggleGroupActive(groupId, isAllowed) {
            const group = this.groups.find(group => group.id === groupId);
            if (!group) return;

            if (group.active) {
                group.active = false;
                return;
            }

            this.groups.forEach(group => {
                const isInAllowed = this.form.salesTableVisibility.groups.includes(group.id);
                if (isAllowed && !isInAllowed) {
                    group.active = false;
                }
                if (!isAllowed && isInAllowed) {
                    group.active = false;
                }
            });

            group.active = true;
        },
        submitGroups() {
            this.isAllowedGroupsEmpty = this.isNotAllowedGroupsEmpty = this.isSaving = this.loading = true;
            this.form.salesTableVisibility.groups = this.allowedGroups.map(group => group.id);
            salesTable.saveTableGroups(this.salesTable.id, this.form)
                .then(() => {
                    this.$store.dispatch('salesTable/updateSalesTablePermissions', JSON.stringify(this.form));
                    this.copyForm()
                    this.selectedGroups.forEach(group => {
                        group.active = false;
                    });
                    this.$toastr.s('Grupos de usuário atualizados com sucesso.');
                })
                .catch(error => this.$toastr.e(error.data.msg || 'Erro ao salvar grupos de usuário.'))
                .finally(() => {
                    this.isAllowedGroupsEmpty = this.isNotAllowedGroupsEmpty = this.isSaving = this.loading = false
                });
        },
        addGroupPermission() {
            if(!this.hasActiveNotAllowedGroups) return
            const selected = this.selectedGroups.map(group => group.id);

            this.form.salesTableVisibility.groups = [
                ...new Set([...this.form.salesTableVisibility.groups, ...selected])
            ];

            this.allowedGroups = this.groups.filter(group =>
                this.form.salesTableVisibility.groups.includes(group.id)
            );

            this.notAllowedGroups = this.groups.filter(group =>
                !this.form.salesTableVisibility.groups.includes(group.id)
            );

            this.groups.forEach(group => (group.active = false));

        },
        removeGroupsPermission() {
            if(!this.hasActiveAllowedGroups) return
            const selected = this.selectedGroups.map(group => group.id);

            this.form.salesTableVisibility.groups = this.form.salesTableVisibility.groups.filter(id =>
                !selected.includes(id)
            );

            this.allowedGroups = this.groups.filter(group =>
                this.form.salesTableVisibility.groups.includes(group.id)
            );

            this.notAllowedGroups = this.groups.filter(group =>
                !this.form.salesTableVisibility.groups.includes(group.id)
            );

            this.groups.forEach(group => (group.active = false));
        },
        copyForm() {
            this.oldForm = JSON.parse(JSON.stringify(this.form))
        }
    },

}
</script>
<style lang="stylus" scoped>
    @import 'styles.styl';
</style>
